'use strict';

import { Entity } from '../Entity';

export class IndPharmacy extends Entity {
  protected pharmacyId;
  protected pharmacyNpi;
  protected pharmacyName;
  protected pharmacyAddress;
  protected pharmacyPhone;
  protected pharmacyPreferred;
  protected archived;
  protected dateTimeArchived;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.pharmacyId = data.pharmacyId;
    this.pharmacyNpi = data.pharmacyNpi;
    this.pharmacyName = data.pharmacyName;
    this.pharmacyAddress = data.pharmacyAddress;
    this.pharmacyPhone = data.pharmacyPhone;
    this.pharmacyPreferred = data.pharmacyPreferred;
    this.archived = data.archived;

    if (data.dateTimeArchived) {
      const dateTimeArchived = data.dateTimeArchived.date.split(' ')[0].split('-');
      this.dateTimeArchived =
        dateTimeArchived[1] + '/' + dateTimeArchived[2] + '/' + dateTimeArchived[0];
    }
  }

  public getPharmacyId() {
    return this.pharmacyId;
  }

  public getPharmacyNpi() {
    return this.pharmacyNpi;
  }

  public setPharmacyNpi(pharmacyNpi) {
    this.pharmacyNpi = pharmacyNpi;

    return this;
  }

  public getPharmacyName() {
    return this.pharmacyName;
  }

  public setPharmacyName(pharmacyName) {
    this.pharmacyName = pharmacyName;

    return this;
  }

  public getPharmacyAddress() {
    return this.pharmacyAddress;
  }

  public setPharmacyAddress(pharmacyAddress) {
    this.pharmacyAddress = pharmacyAddress;

    return this;
  }

  public getPharmacyPhone() {
    return this.pharmacyPhone;
  }

  public setPharmacyPhone(pharmacyPhone) {
    this.pharmacyPhone = pharmacyPhone;

    return this;
  }

  public getPharmacyPreferred() {
    return this.pharmacyPreferred;
  }

  public setPharmacyPreferred(pharmacyPreferred) {
    this.pharmacyPreferred = pharmacyPreferred;

    return this;
  }

  public isArchived() {
    return this.archived;
  }

  public getDateTimeArchived() {
    return this.dateTimeArchived;
  }
}
